import {
  CONFIGURABLE_INTEGRATIONS,
  INTEGRATION_ENUM,
} from "../../constants/constants";

export const encodeState = (payload = {}) => {
  return btoa(JSON.stringify({ ...payload, timestamp: Date.now() }))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
};

export const decodeState = (state) => {
  try {
    const base64 = state.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(base64));
  } catch (err) {
    console.error("Invalid state");
    return null;
  }
};

export const createAuthState = (user, integration, isOnboarding) => {
  let payload = {
    userId: user.uuid,
    integrationId: integration.uuid,
    device: "web",
    accountId: user.org,
    isOnboarding,
  };

  return encodeState(payload);
};

export const getIntegrationAuthUrl = (
  integrationId,
  integrationName,
  state,
) => {
  const name = integrationName?.toLowerCase();

  switch (name) {
    case INTEGRATION_ENUM.FATHOM:
      return `${process.env.REACT_APP_SERVER}/fathom/auth/${state}`;

    case INTEGRATION_ENUM.SLACK:
      return `${process.env.REACT_APP_SERVER}/slack/auth/${state}`;

    case INTEGRATION_ENUM.DISCORD:
    case INTEGRATION_ENUM.GMAIL:
      return `${process.env.REACT_APP_SERVER}/general-auth/auth/${integrationId}?state=${encodeURIComponent(state)}`;

    case INTEGRATION_ENUM.READ_AI:
      return `${process.env.REACT_APP_SERVER}/read-ai/auth/${state}`;

    case INTEGRATION_ENUM.WHATSAPP:
      return `${process.env.REACT_APP_SERVER}/whatsapp/auth/${state}`;

    default:
      return `${process.env.REACT_APP_SERVER}/integration/auth/${state}`;
  }
};

export const getApiKeySteps = {
  granola: [
    "Login to your Granola account",
    "Go to Settings → API Keys",
    "Generate a new API key",
    "Copy the API key securely",
  ],
  fellow_ai: [
    "Log into your Fellow account",
    "Navigate to the Developer API settings section in your User settings",
    "Generate a new API key, giving it a descriptive name",
    "Copy the API key securely",
  ],
};

export const requireSetup = (integrationName, setting) => {
  if (!integrationName) return false;

  const requiresSetup = CONFIGURABLE_INTEGRATIONS.some((integration) =>
    integrationName.toLowerCase().includes(integration),
  );

  if (!requiresSetup) return true;

  const defaultSettings = setting?.defaultSettings;

  if (!defaultSettings || defaultSettings.length === 0) return false;

  return defaultSettings.every((defaultSetting) => {
    if (!defaultSetting?.name) return false;
    if (!defaultSetting?.data || defaultSetting.data.length === 0) return false;
    return defaultSetting.data.every((item) => item?.key && item?.value);
  });
};
